
































import LetterHead from '@/components/LetterHead.vue'
import DocumentHead from '@/containers/DocumentHead.vue'
import DurationTabs from '@/containers/DurationTabs.vue'
import CryptoCurrencyTabs from '@/containers/CryptoCurrencyTabs.vue'
import PriceTable from '@/containers/PriceTable.vue'
import PriceChart from '@/containers/PriceChart.vue'

import CoinsModule from '@/store/modules/coins'
import { CryptoInfo } from '@/store/models'

import store from '@/store'

import { Component, Vue } from 'vue-property-decorator'
import currencyFormatter from 'currency-formatter'

@Component({
  components: {
    PriceChart,
    CryptoCurrencyTabs,
    DocumentHead,
    DurationTabs,
    LetterHead,
    PriceTable
  }
})

export default class CoinCharts extends Vue {
unsubscribeAction!: () => void

cryptocurrencySymbol = this.showSelectedCryptocurrency.toUpperCase();
priceText = currencyFormatter.format(this.showSelectedSpotPrice, { code: this.showSelectedCurrency }) || ''

metaInfo = {
  title: this.showSelectedSpotPrice > 0 ? this.title : ''
}

handleCryptoCurrencyChange (crypto: string) {
  CoinsModule.selectCryptoCurrency(crypto)
}

handleDurationChange (duration: string) {
  CoinsModule.selectDuration(duration)
}

get showSelectedCryptocurrency () {
  return CoinsModule.getSelectedCryptocurrency
}

get showSelectedCurrency () {
  return CoinsModule.getSelectedCurrency
}

get showSelectedSpotPrice () {
  return CoinsModule.getSelectedSpotPrice
}

get showSelectedSpotPrices () {
  return CoinsModule.getSelectedSpotPrices
}

get showSelectedPriceHistory () {
  return CoinsModule.getSelectedPriceHistory
}

get showSelectedPriceDifference () {
  return CoinsModule.getSelectedPriceDifference
}

get showSelectedPercentDifference () {
  return CoinsModule.getSelectedPercentDifference
}

get showSelectedDuration () {
  return CoinsModule.getSelectedDuration
}

get title () {
  return `${this.cryptocurrencySymbol}: ${this.priceText}`
}

beforeMount () {
  const ci: CryptoInfo = { cryptoCurrency: 'BTC', currency: 'USD', durationType: 'day' }
  CoinsModule.fetchPriceHistory(ci)
  CoinsModule.fetchSpotPrices('USD')

  this.unsubscribeAction = store.subscribeAction({
    before: (action) => {
      console.log(`before action ${action.type}`)
    },
    after: (action) => {
      if (action.type === 'coins/selectCryptoCurrency' || action.type === 'coins/selectDuration') {
        const ci: CryptoInfo = {
          cryptoCurrency: CoinsModule.getSelectedCryptocurrency,
          currency: CoinsModule.getSelectedCurrency,
          durationType: CoinsModule.getSelectedDuration
        }
        CoinsModule.fetchPriceHistory(ci)
        CoinsModule.fetchSpotPrices('USD')
      }
    }
  })
}

beforeDestroy () {
  this.unsubscribeAction()
}
}
